<template>
  <div class="sj-panel-halfYear">
    <div
      :class="[
        'sj-panel-halfYear-item',
        {
          current: dateItem.current
        }
      ]"
      v-for="dateItem in dateList"
      :key="dateItem.date"
      @click="handleClick(dateItem)"
      @mouseenter="handleMouseenter(dateItem)"
    >
      <div
        :class="[
          'sj-panel-halfYear-item-inner',
          {
            'is-range': getItemIsRange(dateItem),
            'start-date': getItemIsStartOrEndDate(dateItem),
            'end-date': getItemIsStartOrEndDate(dateItem, 'end'),
            selected: getItemSelected(dateItem)
          }
        ]"
      >
        <span>{{ dateItem.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import mixin from "./mixin";

export default {
  mixins: [mixin],
  data() {
    return {
      formatYear: "YYYY",
      formatHalfQuarter: "YYYY-MM",
      dateList: []
    };
  },
  computed: {
    formatValue() {
      const {
        value,
        range,
        multiple,
        formatHalfQuarter,
        formatHalfQuarterTime
      } = this;
      if (!range) {
        const getValue = val => {
          if (typeof val === "number") {
            return moment(val).format(formatHalfQuarter);
          }
          return "";
        };
        if (!multiple) {
          return getValue(value);
        } else {
          if (Array.isArray(value)) {
            return value.map(item => getValue(item));
          }
          return [];
        }
      } else {
        if (
          Object.prototype.toString.call(value) === "[object Array]" &&
          value[0] &&
          typeof value[0] === "number" &&
          value[1] &&
          typeof value[1] === "number"
        ) {
          return [
            formatHalfQuarterTime(value[0]),
            formatHalfQuarterTime(value[1])
          ];
        }
        return [];
      }
    }
  },
  methods: {
    getDateList() {
      const { currentDate, formatYear, formatHalfQuarter } = this;
      const currentYear = moment(currentDate).format(formatYear);
      const startDateStr = moment(currentYear, formatYear).format(
        formatHalfQuarter
      );
      const currentStr = `${moment().format(formatYear)}-0${
        moment().month() > 5 ? 7 : 1
      }`;

      const dateList = [];
      for (let i = 0; i < 2; i += 1) {
        const nowDate = moment(startDateStr, formatHalfQuarter).add(
          i * 6,
          "months"
        );
        const dateStr = nowDate.format(formatHalfQuarter);
        const dateTime = nowDate.toDate().getTime();
        dateList.push({
          current: currentStr === dateStr,
          date: dateStr,
          dateTime,
          label: i === 0 ? "上半年" : "下半年"
        });
      }
      this.dateList = dateList;
    },
    formatHalfQuarterTime(time) {
      const { formatHalfQuarter } = this;
      return moment(moment(time).format(formatHalfQuarter), formatHalfQuarter)
        .toDate()
        .getTime();
    },
    handleClick(item) {
      const { range, multiple, value } = this;
      if (!range) {
        const inputValue = item.dateTime;
        if (multiple) {
          const nowVal = Array.isArray(value) ? [...value] : [];
          const index = nowVal.indexOf(inputValue);
          if (index === -1) {
            nowVal.push(inputValue);
          } else {
            nowVal.splice(index, 1);
          }
          this.$emit("input", nowVal);
        } else {
          this.$emit("input", inputValue);
          this.$emit("close");
        }
      } else {
        const { choosing } = this;
        this.$emit("update:choosing", !choosing);
        if (!choosing) {
          this.$emit("input", [item.dateTime, item.dateTime]);
          this.$emit("update:chooseStartValue", item.dateTime);
        } else {
          this.$emit("close");
        }
      }
    },
    handleMouseenter(item) {
      const { choosing, chooseStartValue } = this;
      if (choosing) {
        const valueList = [chooseStartValue, item.dateTime].sort(
          (a, b) => a - b
        );
        this.$emit("input", valueList);
      }
    },
    getItemIsRange(dateItem) {
      const { range, formatValue } = this;
      if (range) {
        return (
          dateItem.dateTime >= formatValue[0] &&
          dateItem.dateTime <= formatValue[1]
        );
      }
      return false;
    },
    getItemIsStartOrEndDate(dateItem, type = "start") {
      const index = type === "start" ? 0 : 1;
      const { range, formatValue } = this;
      if (range) {
        return formatValue[index] === dateItem.dateTime;
      }
      return false;
    },
    getItemSelected(dateItem) {
      const { range, multiple, formatValue } = this;
      if (!range) {
        if (!multiple) {
          return formatValue === dateItem.date;
        } else {
          let flag = false;
          for (let i = 0; i < formatValue.length; i += 1) {
            if (formatValue[i] === dateItem.date) {
              flag = true;
              break;
            }
          }
          return flag;
        }
      }
      return false;
    }
  },
  watch: {
    currentDate: {
      immediate: true,
      handler() {
        this.getDateList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.sj-panel-halfYear {
  text-align: center;
  padding: 5px 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 60px);
  align-items: center;

  .sj-panel-halfYear-item {
    .text("caption", "available");
    cursor: pointer;

    &:hover {
      .sj-panel-halfYear-item-inner:not(.selected):not(.start-date):not(.end-date) {
        span {
          background-color: @color-productlight;
        }
      }
    }

    &.current {
      color: @color-highlight;
    }

    .sj-panel-halfYear-item-inner {
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        display: block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: @base-border-radius;
      }
    }

    .selected,
    .start-date,
    .end-date {
      span {
        background-color: @color-highlight;
        color: @color-antibg;
      }
    }

    .is-range {
      background-color: @color-productlight;

      &.start-date,
      &.end-date {
        background-color: transparent;
      }

      &.start-date:not(.end-date) {
        background: linear-gradient(
          to right,
          transparent 50%,
          @color-productlight 50%
        );
      }

      &.end-date:not(.start-date) {
        background: linear-gradient(
          to right,
          @color-productlight 50%,
          transparent 50%
        );
      }
    }
  }
}
</style>
